function Map() {

  return (
    <iframe title='mapToOffice' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3072.7197573005774!2d-86.15916148476745!3d39.633513379463935!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x886b5c342567e3ab%3A0x4d9a38e7cde8ddd4!2sGillum%20Dentistry!5e0!3m2!1sen!2sus!4v1574263459695!5m2!1sen!2sus" width="100%" height='100%'></iframe>
  );
}

export default Map;
